import { UPDATE_CREATORS_SITEMAP } from 'root/src/shared/descriptions/endpoints/endpointIds'
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export const payloadSchema = cronJobPayloadSchema

export default {
	[UPDATE_CREATORS_SITEMAP]: {
		isCron: true,
		payloadSchema,
	},
}
